<template>
  <section class="about-section">
    <div class="container">
      <div class="about-image">
        <router-link :to="{ name: 'About' }">
          <img alt="" src="~@/assets/banner-about.jpeg" />
        </router-link>
      </div>
      <div class="about-content">
        <p class="title">Sobre</p>
        <h2>
          Mais de 2000 imóveis
          <span>vendidos em todo o Brasil.</span>
        </h2>

        <p>
          O DezNoventa é o portal de vendas dos imóveis de propriedade dos
          fundos de investimento geridos pela Ulbrex Asset. Ao longo dos últimos
          3 anos, vendemos mais de 2000 imóveis em todo o Brasil.
        </p>
        <router-link :to="{ name: 'About' }">
          Ler mais
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutSection"
};
</script>

<style lang="scss" scoped>
.about-section {
  padding: 150px 0 50px;

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .about-content {
    max-width: 450px;
    margin-left: 0;

    .title {
      color: rgba(183, 145, 105, 1);
      font-size: 18px;
      line-height: 25px;
      font-weight: 700;
    }

    h2 {
      font-size: var(--size-h2);
      line-height: 40px;
      color: var(--blue-custom);
      font-weight: 300;
      margin-bottom: 60px;

      span {
        display: block;
        font-weight: 700;
        line-height: 40px;
      }
    }

    p {
      font-weight: 300;
      line-height: 29px;
      font-size: var(--size-large);
      color: var(--atomic);
      margin-bottom: 16px;

      span {
        font-weight: 500;
      }
    }

    a {
      text-decoration: none;
      font-size: 24px;
      color: var(--blue-custom);
      font-weight: 400;
    }
  }

  .about-image {
    position: relative;
    max-width: 700px;

    img {
      max-width: 620px;
      width: 100%;
      height: auto;
      border-radius: 30px;
    }
  }

  @media (max-width: 768px) {
    padding: 95px 0 40px;

    .container {
      flex-direction: column;
    }

    .about-content {
      padding-top: 40px;
      margin-left: 0;
      margin-bottom: 32px;

      h2 {
        margin-bottom: 32px;
      }
    }
  }
}
</style>
